import { render, staticRenderFns } from "./action_params.vue?vue&type=template&id=bf22b836&scoped=true&"
import script from "./action_params.vue?vue&type=script&lang=js&"
export * from "./action_params.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf22b836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf22b836')) {
      api.createRecord('bf22b836', component.options)
    } else {
      api.reload('bf22b836', component.options)
    }
    module.hot.accept("./action_params.vue?vue&type=template&id=bf22b836&scoped=true&", function () {
      api.rerender('bf22b836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/actions/modal/tabs/action_params.vue"
export default component.exports